import React, {
  useMemo,
  useState
} from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import { InputImage } from "src/library/components/Forms";
import ImageCropperEditor from "src/library/components/Image/ImageCropperEditor";

import { PromotionTemplate } from "../api/promotions.api";
import { getTemplateAspectRatio } from "../utils/getTemplateAspectRatio";
import { getPromotionImageSize } from "../utils";

export interface PromotionFormImageProps {
  template: PromotionTemplate;
  value?: File;
  handleImageChange: (file: File) => void
}

/**
 * This component is for creating and editting Promotion Images only,
 * not displaying for customer
 */
export const PromotionFormImage: React.ReactFCWithChildren<PromotionFormImageProps> = ({
  template, value, handleImageChange
}) => {
  const [ imgCropperFile, setImgCropperFile ] = useState<{file: File} | null>(null);
  const [ activeEditor, setActiveEditor ] = useState(false);

  const imageSize = useMemo(() => {
    return getPromotionImageSize(template);
  }, [ template ]);

  return (
    <PromotionFormImageWrapper>
      {!activeEditor && (
        <div className="image-wrapper">
          <InputImage
            label=""
            autoHideLabels
            name="image"
            handleChange={event => {
              setImgCropperFile({ file: event.currentTarget.files[ 0 ] });
              setActiveEditor(true);
            }}
            value={value}
            height={imageSize.height}
            width={imageSize.width}
            border={value ? "0" : undefined}
          />
        </div>
      )}

      {imgCropperFile && activeEditor && (
        <ImageCropperEditor
          show
          src={imgCropperFile.file}
          onDismiss={() => setImgCropperFile(null)}
          onSubmit={file => {
            setImgCropperFile(null);
            handleImageChange(file);
            setActiveEditor(false);
          }}
          aspect={getTemplateAspectRatio(template)}
          capImageDisplaySize={imageSize}
        />
      )}

      <div className="image-metrics">
        <Text as="p">
          {`Height: ${imageSize.height}px`}
        </Text>

        <Text as="p">
          {`Width: ${imageSize.width}px`}
        </Text>
      </div>

    </PromotionFormImageWrapper>
  );
};

const PromotionFormImageWrapper = styled.div`
${({ theme }) => css`
    .image-wrapper {
      margin-bottom: ${theme.spacing.margins.md};

      img {
        min-height: 100%;
        min-width: 100%;
        object-fit: cover;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        max-width: 100%;
        max-height: 100%;
        position: absolute;
      }
    }
  `}
`;

export default PromotionFormImage;
